<script setup lang="ts">
import type { HblSlot } from '@/utils/types'

const props = defineProps<{
    content: HblSlot
}>()

const componentId = useId()

const items = computed(() => {
    return [...(props.content?.config?.accordion?.value ?? [])].sort((a, b) => a.position - b.position)
})
</script>

<template>
    <div
        v-if="items.length > 0"
        :class="`cms-element-${content.type}`"
        class="structure-slot-accordion collapse-wrapper md:w-full -mx-2 md:m-auto max-w-[800px]"
        itemscope
        itemtype="https://schema.org/FAQPage"
    >
        <details
            v-for="(item, index) in items"
            :key="index"
            class="collapse group"
            :name="`accordion_${componentId}`"
            itemscope
            itemprop="mainEntity"
            itemtype="https://schema.org/Question"
        >
            <summary
                :id="`trigger_${encodeURIComponent(item.title)}_${index}`"
                itemprop="name"
                class="collapse-title pt-4 pb-3 pl-4 md:pl-3.5 pr-[60px] min-h-0 border-t border-border list-none [&::-webkit-details-marker]:hidden"
            >
                <span class="text-link font-semibold">{{ item.title }}</span>
                <div
                    aria-hidden="true"
                    class="chevron-down-btn absolute right-0 top-2 m-1.5 group-open:hidden"
                >
                    <MiscIcon name="chevron-down" />
                </div>
                <div
                    aria-hidden="true"
                    class="chevron-up-btn absolute right-0 top-2 m-1.5 hidden group-open:!inline-flex"
                >
                    <MiscIcon name="chevron-up" />
                </div>
            </summary>
            <div
                :id="`content_${encodeURIComponent(item.title)}_${index}`"
                class="collapse-content px-0"
                itemscope
                itemprop="acceptedAnswer"
                itemtype="https://schema.org/Answer"
                role="region"
                :aria-labelledby="`trigger_${encodeURIComponent(item.title)}_${index}`"
            >
                <div
                    itemprop="text"
                    class="p-4 text-sm border rounded-lg mb-2"
                >
                    <div
                        class="prose max-w-none text-lg p-6"
                        v-html="item.content"
                    />
                </div>
            </div>
        </details>
    </div>
</template>
